import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { businessInfo } from '../data/mock';
import logoWhite from '../assets/images/logo-white.png';

const Footer = ({ onOpenForm }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (sectionId) => {
    // If not on home page, navigate to home first
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  return (
    <footer className="bg-primary text-white">
      {/* Main Footer Content */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <img 
              src={logoWhite} 
              alt="Register Business Name Trademark" 
              className="h-12 w-auto object-contain mb-4"
            />
            <p className="text-gray-300 text-sm leading-relaxed">
              Your trusted partner in protecting your brand through professional trademark registration services. We specialize in USPTO filings and comprehensive brand protection.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold text-secondary mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {['Home', 'About', 'Services', 'Process', 'Pricing', 'FAQ', 'Contact'].map((item) => (
                <li key={item}>
                  <button
                    onClick={() => scrollToSection(item.toLowerCase())}
                    className="text-gray-300 hover:text-secondary transition-colors text-sm"
                  >
                    {item}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold text-secondary mb-4">Our Services</h4>
            <ul className="space-y-2 text-sm">
              <li className="text-gray-300">Trademark Search</li>
              <li className="text-gray-300">USPTO Filing</li>
              <li className="text-gray-300">Office Action Response</li>
              <li className="text-gray-300">Trademark Monitoring</li>
              <li className="text-gray-300">Brand Protection</li>
              <li className="text-gray-300">Trademark Renewal</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold text-secondary mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="text-secondary mt-1 flex-shrink-0" />
                <span className="text-gray-300 text-sm">{businessInfo.address}</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone size={18} className="text-secondary flex-shrink-0" />
                <a href={`tel:${businessInfo.phone}`} className="text-gray-300 hover:text-secondary transition-colors text-sm">
                  {businessInfo.phone}
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Mail size={18} className="text-secondary flex-shrink-0" />
                <a href={`mailto:${businessInfo.email}`} className="text-gray-300 hover:text-secondary transition-colors text-sm break-all">
                  {businessInfo.email}
                </a>
              </li>
            </ul>
            <button
              onClick={onOpenForm}
              className="mt-4 bg-secondary text-white px-6 py-2 rounded-md hover:bg-secondary/90 transition-all font-semibold text-sm w-full"
            >
              Register Your Trademark
            </button>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-700">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © {new Date().getFullYear()} {businessInfo.name}. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm">
              <Link
                to="/privacy-policy"
                className="text-gray-400 hover:text-secondary transition-colors"
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms-conditions"
                className="text-gray-400 hover:text-secondary transition-colors"
              >
                Terms & Conditions
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
